__turbopack_context__.v({
  "actions": "txpBSG_actions",
  "card": "txpBSG_card",
  "code": "txpBSG_code",
  "main": "txpBSG_main",
  "message": "txpBSG_message",
  "page": "txpBSG_page",
  "primaryBtn": "txpBSG_primaryBtn",
  "secondaryBtn": "txpBSG_secondaryBtn",
  "section": "txpBSG_section",
  "title": "txpBSG_title",
});
